"use client";

import Script from "next/script";
import { useOptionalScriptsAllowed } from "@/lib/consent";

/* Apex Flow Arcade widget (served from apexflowlabs.com). It is optional, so it loads only after
 * the visitor accepts optional scripts; Decline and Global Privacy Control keep it off. */
export function ArcadeScript() {
  const allowed = useOptionalScriptsAllowed();
  if (!allowed) return null;
  return (
    <Script
      src="https://www.apexflowlabs.com/embed/apex-arcade.js"
      data-side="left"
      data-bottom="96"
      strategy="lazyOnload"
    />
  );
}
